export {
  defaultPrimaryNavBrokerLinks,
  defaultPrimaryNavContactLinks,
  defaultFooterLinks,
  createRlaLinks,
  userMenuMap,
  NAV_DEFINITION_DEFAULT,
  NAV_DEFINITION_LATAM,
  NAV_DEFINITION,
} from './lib/nav-config';

export {
  STATIC_PORTAL_CONFIG,
  getPortalFormParsers,
  getPortalFormConfig,
} from './lib/portal-config';

export {
  COUNTRY_NAMES,
  COUNTRY_NAMES_DEFAULT,
  COUNTRY_NAMES_LATAM,
} from './lib/country-names';

export { POLICY_NAMES } from './lib/policy-names';

export { DOCUMENT_CATEGORIES } from './lib/document-categories';

export {
  FinancialClassifications,
  ENABLE_FCA_CLASSIFICATION,
} from './lib/financial-classifications';

export {
  LSOS_COB_META_DATA,
  NORWAY_COB_META_DATA,
  PartnerClassOfBusinesses,
  CobMeta,
  ClassOfBusinessId,
  NorwayClassOfBusinessId,
  AccaClassOfBusinessId,
  AccaOverClassOfBusinessId,
  EnwClassOfBusinessId,
  RegulatoryClassOfBusinessId,
  ConstructionClassOfBusinessId,
  getClassOfBusinessMeta,
  getClassOfBusinessMetaById,
  // new system
  COB_META_DATA,
  COB_META_DATA_DEFAULT,
  provideCobMeta,
  CobMetaOptionsPipeExtension,
  registerCobMetaOptionsPipeExtension,
} from './lib/cob-meta';

export {
  ArgentinaPeopleSolutionsClassOfBusinessId,
  ArgentinaPncClassOfBusinessId,
  BrazilPeopleSolutionsClassOfBusinessId,
  BrazilPncClassOfBusinessId,
  ChilePeopleSolutionsClassOfBusinessId,
  ChilePncClassOfBusinessId,
  ColombiaPeopleSolutionsClassOfBusinessId,
  ColombiaPncClassOfBusinessId,
  MexicoPeopleSolutionsClassOfBusinessId,
  MexicoPncClassOfBusinessId,
  PeruPeopleSolutionsClassOfBusinessId,
  PeruPncClassOfBusinessId,
  UruguayPeopleSolutionsClassOfBusinessId,
  UruguayPncClassOfBusinessId,
  COB_META_DATA_LATAM,
} from './lib/latam-cob-meta';

export { CobMetaService } from './lib/cob-meta.service';

export {
  TEMP_COB_DATA,
  TEMP_COB_DATA_DEFAULT,
  TEMP_COB_DATA_LATAM,
  TempCobMeta,
} from './lib/temp-cob-data';

export { default as enGb } from './lib/api-messages.json';
export { default as nb } from './lib/api-messages.nb.json';

export {
  ERROR_MESSAGES,
  getUserFriendlyErrorMessageForHttpErrors,
  getUserFriendlyErrorMessageForNoInternet,
} from './lib/error-messages';

export {
  LsosProductConfigId,
  NorwayProductConfigId,
  AccaProductConfigId,
  PncProductConfigId,
  AccaOverProductConfigId,
  ConstructionProductConfigId,
  RegulatoryProductConfigId,
  EnwProductConfigId,
  PerformanceProductConfigId,
  getPartnerCobProps,
  DEFAULT_PRODUCT_CONFIG_ID,
} from './lib/product-config';

export { APPLICATION, Application } from './lib/application';

export {
  ENDORSEMENTS_DEF,
  ENDORSEMENTS_DEF_DEFAULT,
  ENDORSEMENT_META_DATA,
  ENDORSEMENT_META_DATA_DEFAULT,
  AccaEndorsementsId,
  EndorsementsDef,
  EndorsementsMeta,
} from './lib/endorsement-meta';

export { EndorsementMetaService } from './lib/endorsement-meta.service';

export { InsurerMetaService } from './lib/insurer-meta.service';
export { provideInsurerMeta } from './lib/insurer-meta';
